import { COLORS } from '@constants';
import { Button } from '@ui';
import styled from 'styled-components';
import { HeaderRow, OptionRow, OptionsGrid } from '../../../../components/layout/rows/styled';
import {
    OptionCard,
    OptionContent,
    OptionDescription,
    OptionNote,
    OptionTitle
} from '../../../../components/OptionCard/styled';

export { HeaderRow, OptionRow, OptionsGrid };
export { OptionCard, OptionContent, OptionDescription, OptionNote, OptionTitle };

export const Container = styled.div`
    width: 100%;
`;

export const StyledButton = styled(Button)`
    border: 2px solid ${COLORS.$gray20Black};
    border-radius: 8px;
    height: 56px;
    width: 187px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: ${COLORS.$white};

    &:hover {
        border-color: ${COLORS.$gray40Black};
    }
`;
